import { ActionButton, actionButtonStyles } from "./ActionButton";

interface CloseButtonProps {
  onClose: () => void;
}

export function CloseButton({ onClose }: CloseButtonProps) {
  return <ActionButton icon="close" onPress={onClose} tooltip="Close" style={actionButtonStyles.iconBtn} />;
}
